import { region, shippingRule } from "@/common/type";
import { AxiosResponse } from "axios";
import { api } from "../util/api";

export async function getSystemConfig(): Promise<any> {
  return api.get("/api/systemConfig");
}
export async function updateSystemConfig(body: any) {
  return api.patch("/api/systemConfig", body);
}

export async function getAllRegion(): Promise<AxiosResponse<region[]>> {
  return api.get("/api/systemConfig/region");
}

export async function updateShippingRule(body: any) {
  return api.patch("/api/systemConfig/shippingRule", body);
}
export async function getAllShippingRule(): Promise<
  AxiosResponse<shippingRule[]>
> {
  return api.get("/api/systemConfig/shippingRule");
}
export async function deleteShippingRule(id: number) {
  return api.delete("/api/systemConfig/shippingRule", { id });
}
export async function newShippingRule(body: any) {
  return api.post("/api/systemConfig/shippingRule", body);
}
